import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./RadioButtonList.styled"

export function RadioButtonList(props) {

    const {
        className,
        itemsList,
        onChange,
        selectedValue,
        color = "primary",
    } = props

    return <Styled.RadioGroup className={className}>
        {
            itemsList.map((item) => {
                const isSelected = selectedValue === item.value
                const iconColor = isSelected ? "primary" : "default"
                const icon = item.icon ? item.icon({ color: iconColor }) : null

                return (
                    !item.value ? item
                        : <Styled.ListItemButton
                            disabled={item.disabled}
                            selected={isSelected}
                            onClick={() => onChange(item.value)}
                            key={item.id}
                        >
                            {icon}
                            <Styled.Typography variant="Desktop & Mobile/Body/Regular">{item.label}</Styled.Typography>
                            <Styled.Radio checked={selectedValue === item.value} disableRipple color={color} />
                        </Styled.ListItemButton>
                )
            })
        }
    </ Styled.RadioGroup>
}

RadioButtonList.propTypes = {
    itemsList: PropTypes.arrayOf(
        PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.shape({
                disabled: PropTypes.bool,
                id: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
                value: PropTypes.string.isRequired,
                icon: PropTypes.elementType,
            }).isRequired]),
    ),
    onChange: PropTypes.func.isRequired,
    color: PropTypes.oneOf(["primary", "default"]),
}